/*
 * Created on Wed Aug 09 2023
 *
 * Project: BKN_FRONT
 * Copyright (c) 2023 Nttdata
 */
import React from "react";
import { Skeleton } from '@mui/material';
import  { GridOverlay } from '@mui/x-data-grid';

export const CustomLoadingOverlay = () => {
    return (
      <GridOverlay>
        <div style={{ position: 'absolute', top: 0, left: 0, height: '100%', width: '100%' }}>
          <br></br>
            <Skeleton variant="rectangular" height={50} animation="pulse" />
          <br></br>
            <Skeleton variant="rectangular" height={50} animation="pulse" />
          <br></br>
            <Skeleton variant="rectangular" height={50} animation="pulse" />
          <br></br>
            <Skeleton variant="rectangular" height={50} animation="pulse" />
          <br></br>
            <Skeleton variant="rectangular" height={50} animation="pulse" />
          <br></br>
            <Skeleton variant="rectangular" height={50} animation="pulse" />
          <br></br>
            <Skeleton variant="rectangular" height={50} animation="pulse" />
          { }
        </div>
      </GridOverlay>
    );
  };